import { SessionExpiredError } from "../types";

/**
 * Wraps an API so any call that fails with SessionExpiredError also tells the session store, which then shows the
 * "Your session ended" dialog over the page (FR-ADMIN-047). Results and other errors pass through unchanged.
 */
export function withSessionGuard<T extends object>(api: T, onExpired: () => void): T {
  return new Proxy(api, {
    get(target, property, receiver) {
      const value: unknown = Reflect.get(target, property, receiver);
      if (typeof value !== "function") return value;
      return (...args: unknown[]) => {
        const result: unknown = Reflect.apply(value, target, args);
        if (!(result instanceof Promise)) return result;
        return result.catch((error: unknown) => {
          if (error instanceof SessionExpiredError) onExpired();
          throw error;
        });
      };
    },
  });
}
